import InternalNoteCard from '@components/internalNote/InternalNoteCard'
import MembershipSubscription from '@components/membership/subscription/MembershipSubscription'
import { useMembershipProfileContext } from '@contexts/membership/MembershipProfileContext'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getMembershipProfileWithId,
  selectMembershipProfileById,
  updateMembershipProfile,
} from '@store/membership/MembershipProfileReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Flex } from 'antd'

const SubscriptionSection = () => {
  const dispatch = useAppDispatch()
  const { id } = useMembershipProfileContext()
  const membershipProfile = useAppSelector(selectMembershipProfileById(id))

  if (!membershipProfile) return null

  return (
    <Flex vertical gap={24}>
      <InternalNoteCard
        entityId={membershipProfile.id}
        fetchNote={() =>
          Promise.resolve(membershipProfile.internalNote ?? null)
        }
        saveNote={(note) =>
          dispatch(
            updateMembershipProfile({
              ...membershipProfile,
              internalNote: note,
            })
          )
        }
      />
      <Flex vertical gap={8}>
        <PageTitle level={5} title="Subscription" style={{ margin: 0 }} />
        <Flex vertical gap={24}>
          <MembershipSubscription.Description
            id={membershipProfile.subscription}
            onChange={() => dispatch(getMembershipProfileWithId(id))}
          />
          <MembershipSubscription.PaymentData
            id={membershipProfile.subscription}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default SubscriptionSection
